import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { apiUrl } from './envirenment';
import { Types, DTO } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  private socket?: Socket;

  connect(callback: () => void) {
    const token = localStorage.getItem('JWT_Token');
    if (token) {
      this.socket = io(`${apiUrl}?token=${token}`, {
        transports: ['websocket'],
      });

      this.socket?.on('connect', callback);
    }
    if (!token) {
      console.log('❌ Não foi possivel conectar com WebSocket');
    }
    console.log('✅ Conectado ao WebSocket');
    return !!token;
  }

  disconnect() {
    this.socket?.disconnect();
  }

  sendEvent<T>(event: Types.EChatEvents, data: DTO.ChatEventDTO<T>): void {
    this.socket?.emit(event, data);
  }

  addListener<T>(event: Types.EChatEvents, callback: (data: T) => void) {
    this.socket?.on(event, callback);
  }
}
